// extracted by mini-css-extract-plugin
export default {"dataTable":"DataTable__dataTable__g3ejP","kvContainer":"DataTable__kvContainer__uMeYx","keyBox":"DataTable__keyBox__udVdf","valueBox":"DataTable__valueBox__l_mwi"};